import { Dialog, DialogTitle, DialogActions, DialogContent, Button, Typography } from "@mui/material";
import { ComparisonContainer, ComparisonItem } from "./styles";
import { InterchangeActivityTypeLabel, AssetTypeLabel } from "../../../constants/securspace-constants";
import { DialogProps } from "../../data";

const DeleteInterchangeDialog = (props: DialogProps) => {
  const {open, interchange, onClose, onAction} = props;

  const handleSubmit = () => {
    onAction(interchange.id)
  };

  return <Dialog open={open}>
    <DialogTitle>Delete Activity</DialogTitle>
    <DialogContent>
      <Typography>Are you sure you want to delete this interchange?</Typography>
      <ComparisonContainer>
        <ComparisonItem>
          <Typography>Activity:</Typography>
          <Typography>{InterchangeActivityTypeLabel[interchange?.activity as keyof typeof InterchangeActivityTypeLabel]}</Typography>
        </ComparisonItem>
        <ComparisonItem>
          <Typography>Date:</Typography>
          <Typography>{interchange?.activityDate}</Typography>
        </ComparisonItem>
        <ComparisonItem>
          <Typography>Equipment:</Typography>
          <Typography>{AssetTypeLabel[interchange?.assetType as keyof typeof AssetTypeLabel]}</Typography>
        </ComparisonItem>
      </ComparisonContainer>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={handleSubmit}>Delete</Button>
    </DialogActions>
  </Dialog>
};

export default DeleteInterchangeDialog;